import './editor-block-button.scss';

import { CustomFormattedMessage } from '../../../intl/custom-formatted-message';

export type BlockButtonProps = {
  format: string;
  isToggle?: boolean;
  active?: boolean;
  wide?: boolean;
  disabled?: boolean;
  text?: string;
  onClick?: () => void;
};
export function EditorBlockButton({
  active,
  onClick,
  format,
  disabled,
  text,
  wide,
  isToggle = true,
}: BlockButtonProps) {
  return (
    <button
      aria-label={format}
      type="button"
      disabled={disabled}
      onClick={() => {
        onClick?.();
      }}
      className={`editor-block-button ${
        active ? 'editor-block-button--active' : ''
      } ${isToggle ? 'editor-block-button--toggle' : ''}  ${
        wide ? 'editor-block-button--wide' : ''
      }`}
    >
      <i
        className={`editor-block-button__icon editor-block-button__icon--${format}`}
      />
      {text && (
        <span className="editor-block-button__text">
          <CustomFormattedMessage id={`editor.format-${format}`} />
        </span>
      )}
    </button>
  );
}
